var Flickity = require("flickity")

window.addEventListener("load", (event) => {
  var elem = document.querySelector(".parallax--container")
  // Initialization
  var sliderWrapperParallax = document.querySelector(".parallax_slider")
  var durationParallax = 4
  var intervalParallax = 10

  if (elem) {
    var single = false // Is it single ?
    var cells = document.querySelectorAll(".parallax-item").length
    if (cells <= 1) {
      single = true
      sliderWrapperParallax.classList.add("single-parallax")
      //let singleHeightItem = document.querySelector(".parallax-cover").offsetHeight;
      //sliderWrapperParallax.style.minHeight = singleHeightItem;
    }

    if (!single) {
      if (elem.dataset.durationParallax) durationParallax = elem.dataset.durationParallax
      var flkyParallax = new Flickity(".parallax--container", {
        // options
        cellAlign: "left",
        contain: false,
        cellSelector: ".parallax-item",
        adaptiveHeight: false,
        pauseAutoPlayOnHover: false,
        fade: true,
        imagesLoaded: true,
        draggable: true,
        freeScroll: false,
        groupCells: false,
        initialIndex: 0,
        lazyLoad: true,
        percentPosition: true,
        prevNextButtons: false,
        pageDots: true,
        resize: true,
        rightToLeft: false,
        setGallerySize: false,
        watchCSS: false,
        wrapAround: true,
        // selectedAttraction: 0.01,
        // friction: 0.15,
        // autoPlay: true,
        // autoPlay: 4000
      });

      flkyParallax.on('change', function(index) {
        let slideNumber = index + 1;
        track('Homepage', `Parallax Slider ${slideNumber} Displayed`, {
          displayMethod: lastClickIsManual ? 'manual' : 'auto',
        });
        lastClickIsManual = false;
      })

      // Pause control
      var isPausedParallax = false

      // Tracks if last change was manual or auto for analytics
      var lastClickIsManual = false



      sliderWrapperParallax.addEventListener("mouseleave", function () {
        isPausedParallax = false
      })

      // Main function
      var percentTimeParallax, stepParallax, tickParallax

      function startProgressbarParallax() {
        resetProgressbarParallax()
        percentTimeParallax = 0
        isPausedParallax = false //false
        tickParallax = window.setInterval(increase, intervalParallax)
      }

      function increase() {
        if (!isPausedParallax) {
          stepParallax = (durationParallax * 1000) / intervalParallax
          percentTimeParallax += 100 / stepParallax

          //progressBar.style.width = percentTimeParallax + "%";
          $(".parallax--container .dot span").css("width", "0%")
          $(".parallax--container .dot.is-selected span").css("width", percentTimeParallax + "%")
          //$('.dot.is-selected').css("width", percentTimeParallax + '%');

          if (percentTimeParallax >= 100) {
            flkyParallax.next()
            startProgressbarParallax()
          }
        }
      }

      function resetProgressbarParallax() {
        $(".parallax--container .dot.is-selected span").css("width", "0%")
        clearTimeout(tickParallax)
      }

      startProgressbarParallax()

      //Moving dots
      $(".parallax--container .flickity-page-dots").appendTo(".parallax--container")
      $(".parallax--container .flickity-page-dots .dot").each(function () {
        $(this).append("<span></span>")
      })

      $(".parallax--container .flickity-page-dots .dot").bind("DOMSubtreeModified", function () {
        stepParallax = (durationParallax * 1000) / intervalParallax
        percentTimeParallax = 0
        $(".parallax--container .dot span").css("width", "0%")
        $(".parallax--container .dot.is-selected span").css("width", 0 + "%")
      })

      $(".parallax--container .flickity-page-dots .dot").on("click", function (e) {
        isPausedParallax = true
        lastClickIsManual = true;
      })

      // let wd = $(window).width();
      // let is_mob = wd > 992 ? false : true;

      // if (is_mob) { }
      let parent = $(".parallax--container")
      let heightItem = parent.find(".parallax-cover").outerHeight()
      parent.find(".parallax-item").css("min-height", heightItem)
      parent.find(".flickity-viewport").css("height", heightItem)
    }
  }
})

// parallax
